/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderDeliveryInfoCargoSeparateItem } from './order_delivery_info_cargo_separate_item'
import type { OrderDeliveryInfoCargoSize } from './order_delivery_info_cargo_size'
import type { OrderDeliveryInfoCargoTotal } from './order_delivery_info_cargo_total'
/**
 * Информация о грузе
 */
export type OrderDeliveryInfoCargoInfoRequest = {
  /**
   * Параметр, определяющий в каком виде в заказе представлена информации о грузе (возможные значения: Separate - отдельные грузоместа, Total - общий вес и объем, Size - груз стандартного размера)
   */
  type: OrderDeliveryInfoCargoInfoRequest.type
  /**
   * Грузоместа
   */
  separate?: Array<OrderDeliveryInfoCargoSeparateItem>
  /**
   * Информация о грузе в виде общего веса и объема
   */
  total?: OrderDeliveryInfoCargoTotal
  /**
   * Груз стандартного размера
   */
  size?: OrderDeliveryInfoCargoSize
}
export namespace OrderDeliveryInfoCargoInfoRequest {
  /**
   * Параметр, определяющий в каком виде в заказе представлена информации о грузе (возможные значения: Separate - отдельные грузоместа, Total - общий вес и объем, Size - груз стандартного размера)
   */
  export enum type {
    SEPARATE = 'separate',
    TOTAL = 'total',
    SIZE = 'size'
  }
}
